import { useEffect, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import {
  boundStartShop,
  isStartGateOpen,
  LABELS_BUDGET_MS,
  releaseStartGate,
  startText,
  StartLabel,
  startTextsVersion,
  subscribeStartTexts,
} from '../utils/helpers';

// #493 (S3): the start-page texts of the URL shop for a component of the
// returns flow. `active` false (another flow, or no shop bound): `text` is
// always undefined and the gate open, so the caller shows its static texts
// exactly as before. `ready` is the render gate of the start form.
export const useStartTexts = (active: boolean) => {
  useSyncExternalStore(subscribeStartTexts, startTextsVersion);
  // re-renders on a language change and on every bundle added / removed
  useTranslation(['translation', 'dynamic']);
  const applicable = active && boundStartShop() !== null;
  const ready = !applicable || isStartGateOpen();
  // safety net: the gate never stays closed beyond the budget, even if no
  // selection loads the texts
  useEffect(() => {
    if (ready) return;
    const timer = setTimeout(releaseStartGate, LABELS_BUDGET_MS);
    return () => clearTimeout(timer);
  }, [ready]);
  return {
    ready,
    // `staticKey`: the static text of the label, used in the requested
    // language while the entry selection is not applied yet (review r2)
    text: (label: StartLabel, staticKey: string): string | undefined =>
      applicable ? startText(label, staticKey) : undefined,
  };
};
